import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { MapChartCard } from "@/partner/shared/components/MapChartCard";
import { useAnalyticsSalesByCountryQuery } from "@/partner/entities/analytics";

export const AnalyticsSalesByCountryMap: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  const { data, loading, error } = useAnalyticsSalesByCountryQuery({
    variables: { filter: filter as never, limit: 300 },
  });

  return (
    <MapChartCard
      title={t("analytics.sales.mapByCountry")}
      data={data?.analyticsSales.salesByCountry}
      loading={loading}
      error={error}
      field="revenue"
    />
  );
};
